import { render, staticRenderFns } from "./main.pedidos.vue?vue&type=template&id=2cb8cb86"
import script from "./main.pedidos.vue?vue&type=script&lang=js"
export * from "./main.pedidos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports